import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./styles/toast.css";
// import "./fonts.css"
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.min.css";
import ProtectedRoute from "./routes/ProtectedRoute";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "./theme";
import UserLogin from "./pages/user/UserLogin";
import Tables from "./pages/table/Tables";
import Main from "./pages/main/Main";
// import Promotion from "./pages/promotion";
import { useInfoStore } from "./store/userInfo";
import { useMenuStore } from "./store/menuState";
// import dining_bg from '../assets/images/dining_bg.png';
// import nowifi from '../assets/images/nowifi.svg';
import DiningOptions from "./pages/main/Kiosk/DiningOpt";
import CollectCustomer from "./pages/main/Kiosk/CallName";
import MyOrder from "./pages/main/Kiosk/MyOrder";
// import { isBrowser } from "react-device-detect";
import AyceMenu from "./pages/main/AyceMenu";
import ErrorBoundary from "./ErrorBoundary";
import { menuItem, promotionItem } from "./types/menu";
import { createGlobalStyle } from "styled-components";
import useIdleTimeout from "./context/IdleTimeout";
import { isBrowser, isTablet, isIOS } from "react-device-detect";
import { AnalyticsProvider } from "./analytics/AnalyticsContext";
import PageTracker from "./analytics/PageTracker";
import { Analytics } from 'aws-amplify';
import { AppKeyContext } from './context/AppKeyContext';
import TimerProvider from "./context/TimerProvider";
import { devLog, logger } from './utils/logger';
import * as serviceWorker from './serviceWorker';
import { safeDeploymentInit } from './utils/deploymentUtils';

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  let orientation = width > height ? "landscape" : "portrait";
  let minWidth = width;
  let minHeight = height;
  
  // Set CSS Custom Property for vh
  const vh = height * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  return {
    width: minWidth,
    height: minHeight,
    orientation,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    // Initial setup
    handleResize();

    // Handle both resize and orientation change
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return windowDimensions;
};

const GlobalStyles = createGlobalStyle<{ width: number}>`
    html {
      font-size: 62.5%;
      touch-action: manipulation;
      height: 100%;
    }

    :root {
      --scale-factor: ${({ width }) => Math.max((width / 1280), 0.28125)};
      --vh: 1vh;
    }

    @media screen and (max-width: 700px) {
      html {
        font-size: 28.1% !important;
        touch-action: manipulation;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      :root {
        --scale-factor: ${({ width }) => Math.max(width / 1280, 0.28125)};
      }
      body {
        font-size: 28.1% !important;
        touch-action: manipulation;
        overflow: hidden;
        height: calc(var(--vh, 1vh) * 100);
        /* iOS의 100vh 문제를 해결하기 위한 설정 */
        min-height: -webkit-fill-available;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }

      #root {
        height: 100%;
        padding-bottom: env(safe-area-inset-bottom);
        padding-top: env(safe-area-inset-top);
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }

      * {
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
    }

    @media screen and (min-width: 1280px) {
      html {
        font-size: calc(max(10 / ${({ width }) => 16 * (width / 1280)}, 0.625));
        touch-action: manipulation;
      }

      :root {
        --scale-factor: ${({ width }) => Math.max((width / 1280), 1.0)};
      }
    }

    body {
      font-size: calc(max(16px * var(--scale-factor), 16px));
      margin: 0;
      padding: 0;
      height: 100%;
    }

    /* QR 모드일 때 모든 터치 및 롱프레스 동작 비활성화 */
    [data-login-mode="qr"] {
      -webkit-touch-callout: none !important;
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
      touch-action: none !important;
      pointer-events: none !important;
    }

    [data-login-mode="qr"] * {
      -webkit-touch-callout: none !important;
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
      touch-action: none !important;
      pointer-events: none !important;
    }
  `;

const App: React.FC = () => {
  // const [value, setValue] = React.useState('recents');
  const {width} = useWindowDimensions()
  const theme = createTheme();
  const [status, setStatus] = useState(true);
  const { isLogin, setIsLogin, setUserInfo } = useInfoStore();
  const { setIsNativeFlag } = useMenuStore()
  // const { idleTimer } = useIdleTimeout({ idleTime: 60 });
  const [appKey, setAppKey] = useState(0);
  // Android Native Menu Data
  const [menuData, setMenuData] = useState<menuItem[]>([]);
  const { setMenuDao } = useMenuStore((state) => ({
    menuDao: state.menuDao,
    setMenuDao: state.setMenuDao,
  }));

  // Android Native Promotion Data
  const [promotionData, setPromotionData] = useState<promotionItem[]>([]);
  const {setPromotionDao } = useMenuStore((state) => ({
    promotionDao: state.promotionDao,
    setPromotionDao: state.setPromotionDao,
  }));
  // logger.log('ratio',orientation)
  useEffect(() => {
    if (isLogin) setIsLogin(false);
  }, []);

  const refreshApp = () => {
    devLog('refreshApp')
    setAppKey((prev) => prev + 1);
  };

  /*************************************************/
  useEffect(() => {
    const setNativeData = (event: MessageEvent) => {
      logger.log("Raw Event Data:", event.data);

      try {
        // Webpack HMR 메시지 필터링
        if (
          typeof event.data === "string" &&
          event.data.startsWith("webpackHotUpdate")
        ) {
          logger.warn("Ignoring Webpack HMR message:", event.data);
          return; // HMR 메시지는 무시
        }

        // JSON 파싱 시도
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data.action === "refresh") {
          logger.log("🌀 App 전체 리렌더 트리거 수신");
          setAppKey(prev => prev + 1);
        }
        // 유저 정보
        else if (data.action === "userInfo") {
          setUserInfo(data.payload);
          setIsLogin(true);
          logger.log("Received userInfo:", data.payload);
        }
        // 메뉴 정보
        else if (data.action === "menuData") {
          if (!data.payload || !Array.isArray(data.payload)) {
            logger.error("Invalid menuData payload:", data.payload);
            return;
          }
          // 기존 메뉴 데이터 클리어
          setMenuData([]);
          setMenuDao([]);
          // 새로운 데이터 설정
          setMenuData(data.payload);
          setMenuDao(data.payload);
          logger.log("Menu Dao Updated:", data.payload);
        }
        // 프로모션 정보
        else if (data.action === "promotionData") {
          if (!data.payload || !Array.isArray(data.payload)) {
            logger.error("Invalid promotionData payload:", data.payload);
            return;
          }
          // 기존 프로모션 데이터 클리어
          setPromotionData([]);
          setPromotionDao([]);
          logger.log("Received promotion data:", {
            count: data.payload.length,
            data: data.payload
          });
          // 새로운 데이터 설정
          setPromotionData(data.payload);
          setPromotionDao(data.payload);
          logger.log("Promotion Dao Updated:", data.payload);
        }
        // 네이티브 앱 판단 여부
        else if (data.action === "isAppFlag") {
          setIsNativeFlag(true)
          Analytics.disable();  
          logger.log("isAppFlag");
        }

      } catch (error) {
        logger.error("Error parsing message:", error, event.data);
      }
    };

    window.addEventListener("message", setNativeData);
    return () => window.removeEventListener("message", setNativeData);
  }, []);


  useEffect(() => {
    /** iOS + 모바일 Safari 전용 처리 */
    if (isIOS && !isTablet && !isBrowser) {
      /* 1️⃣ <meta viewport> : 자동 확대 & 더블-탭 확대 방지 */
      const viewportMeta =
        document.querySelector<HTMLMetaElement>('meta[name="viewport"]');

      if (viewportMeta) {
        viewportMeta.setAttribute(
          'content',
          'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no',
        );
      }

      /* 2️⃣ 핀치·더블탭 줌 차단 (iOS 10~12 대응) */
      const stopMultiTouch = (e: TouchEvent) => {
        if (e.touches.length > 1) e.preventDefault();
      };
      const stopGesture = (e: Event) => e.preventDefault();

      document.addEventListener('touchstart', stopMultiTouch, { passive: false });
      document.addEventListener('gesturestart', stopGesture, { passive: false });

      /* 3️⃣ 정리 */
      return () => {
        document.removeEventListener('touchstart', stopMultiTouch);
        document.removeEventListener('gesturestart', stopGesture);
      };
    }

    /** 그 밖의 모바일(안드로이드 등) – 확대 허용 */
    if (!isTablet && !isBrowser) {
      const viewportMeta =
        document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
      viewportMeta?.setAttribute(
        'content',
        'width=device-width,initial-scale=1,maximum-scale=3,user-scalable=yes',
      );
    }
  }, [isIOS, isTablet, isBrowser]);

  // 배포 시 안전한 초기화
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION || '1.0.0';
    const hasUpdate = safeDeploymentInit(currentVersion);
    
    if (hasUpdate) {
      logger.log('Update detected, app will reload safely');
    }
  }, []);

  // 서비스 워커 업데이트 감지 및 안전한 리로드
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        logger.log('Service Worker controller changed, reloading for safety');
        window.location.reload();
      });

      // 새 서비스 워커가 설치되면 자동으로 활성화
      navigator.serviceWorker.ready.then((registration) => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    }
  }, []);
  
  return (
    <ErrorBoundary>
      <AnalyticsProvider>
        <AppKeyContext.Provider value={{ refreshApp }}>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CssBaseline />
              <GlobalStyles width={width} />
              <ToastContainer 
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <PageTracker />
              <TimerProvider />
              <div key={appKey}>
                  <Routes>
                    <Route index path="/userlogin" element={<UserLogin />} />
                    <Route path="/" element={<ProtectedRoute />}>
                    <Route path="/storesetting" element={<Tables />} />
                    <Route path="/aycemenu" element={<AyceMenu />} />
                    <Route index path="/main" element={<Main />} />
                    {/* <Route index path="/promotion" element={<Promotion />} /> */}
                    <Route path="/diningoption" element={<DiningOptions />} />
                    <Route path="/callName" element={<CollectCustomer />} />
                    <Route path="/myorder" element={<MyOrder />} />
                  </Route>
                </Routes>
              </div>
            </LocalizationProvider>  
          </ThemeProvider>
        </AppKeyContext.Provider>
      </AnalyticsProvider>
    </ErrorBoundary>
  );
};

export default App;
